<script lang="ts" setup>
import { Batch } from '@/core/collections/batches/batch.interface';
import { NxtProgressCircle } from '@nxtpeople/nxt-styles';

//#region globals
const { t } = useI18n();
//#endregion

//#region Props & Emits
defineEmits<{ (e: 'onDeleteBatch', batch: Batch): void }>();
defineProps<{ batch: Batch }>();
//#endregion
</script>

<template>
   <NxtCard>
      <div :class="'batch-job-notification'">
         <p class="batch-job-notification__title">
            {{ t(`batches.${batch.job_batch.name}`) }}
         </p>

         <NxtProgressCircle
            v-show="batch.job_batch.total_jobs"
            :max-value="batch.job_batch.total_jobs"
            :value="batch.job_batch.total_jobs - batch.job_batch.pending_jobs - batch.job_batch.failed_jobs"
            :class="'batch-job-notification__progress'"
         />

         <NxtIconButton
            :class="'batch-job-notification__close'"
            :name="'times'"
            :hover-text="$t('actions.dismiss')"
            @on-click="$emit('onDeleteBatch', batch)"
         />
      </div>
   </NxtCard>
</template>

<style lang="scss" scoped>
.batch-job-notification {
   display: grid;
   grid-template-columns: 1fr auto auto;
   min-width: toRem(200);
   align-items: center;

   padding: var(--nxt-gutter-small);
}
.batch-job-notification__title {
   margin: 0;
   padding-right: var(--nxt-gutter);
}

.batch-job-notification__close {
   color: var(--nxt-white);
}

.batch-job-notification__progress {
   margin-right: var(--nxt-gutter);
}
</style>
